<template>
  <div class='btn-group'>
      <atom-button><router-link :to="{name: 'home'}">Home</router-link></atom-button>
      <atom-button><router-link :to="backRoute">Back</router-link></atom-button>
      <atom-button><router-link :to="nextRoute">Continue</router-link></atom-button>
      <atom-button><router-link :to="{name: 'home'}">Close</router-link></atom-button>
   </div>
</template>

<script>
import AtomButton from '@/components/atoms/Login/Button';

export default {
   name: 'save-continue-btns',
   components: {
      AtomButton,
   },
   props: {
      nextRoute: {
         required: true,
         validator: route => typeof(route.name)==='string',
      },
      backRoute: {
         required: true,
         validator: route => typeof(route.name)==='string',
      },
   },
}
</script>

<style lang="scss" scoped>
.btn-group {
   display: flex;
   flex-wrap: wrap;
   margin: 5px 0;
   > * {
      margin: 2px 0.3em 2px 0;
      a {
         color: inherit;
      }
      &:last-child {
         margin-right: 0;
      }
   }
}
</style>
